
<h1 mat-dialog-title>Flight-Deck Admin Tools</h1>
<mat-dialog-content>
  <mat-tab-group dynamicHeight>
    <mat-tab label="Add/Remove Manager">
      <div>
        <table class="data-block">
          <thead>
          <tr>
            <th class="data-block__label">Manager Name</th>
            <th class="data-block__label">AOPA Member Number</th>
            <th class="data-block__label">Primary POC</th>
            <th class="data-block__label">FBO Fee POC</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let admin of business.admins; let i = index">
            <td class="data-block__value">
              {{admin.firstName}}&nbsp;{{admin.lastName}}
              <mat-icon *ngIf="!adminDeleteConfirmationArray[i]" (click)="onDeleteAdmin(i)" class="delete-icon"
                        mat-tooltip="Revoke admin permission from this business">delete_outline</mat-icon>
              <span class="admin-business__deleteConfirmation" *ngIf="adminDeleteConfirmationArray[i]">
                Delete? <button class="mat-raised-button submit-button" (click)="onDeleteConfirm(admin.recid, i)">Yes</button>
                <button class="mat-raised-button submit-button" (click)="onDeleteAdmin(i)">No</button>
              </span>
            </td>
            <td class="data-block__value">{{admin.recid}}</td>
            <td class="data-block__value"><mat-checkbox [checked]="admin.primaryPoc"
                                                        (change)="pocCheckBoxChanged($event, admin.recid, admin.fboFeePoc)"></mat-checkbox></td>
            <td class="data-block__value"><mat-checkbox [checked]="admin.fboFeePoc"
                                                        (change)="feePocCheckBoxChanged($event, admin.recid, admin.primaryPoc)"></mat-checkbox></td>
          </tr>
          </tbody>
        </table>
        <form #addAdminForm name="form" (ngSubmit)="f.form.valid && onAddAdmin(f)" #f="ngForm" novalidate>
          <mat-form-field #addAdminMatFormField class="recid-field">
            <input #addAdminInput matInput placeholder="AOPA Member Number" type="text" name="recid" [(ngModel)]="model.recid" #recid="ngModel"
                   [ngClass]="{ 'is-invalid': f.dirty && model.recid.length > 0 && recid.invalid }" required minlength="2" maxlength="8" width="10"
                   (keyup)="onKeyUp()" ngModel />
          </mat-form-field>
          <button class="mat-raised-button submit-button add-admin-submit-btn">
            Add Admin
          </button>
          <div *ngIf="f.dirty && model.recid.length > 0 && recid.invalid" class="invalid-feedback">
            <div *ngIf="recid.errors.required">AOPA Member Number is required.</div>
            <div *ngIf="recid.errors.minlength">AOPA Member Number must be at least 2 digits.</div>
            <div *ngIf="recid.errors.maxlength">AOPA Member Number must be less than 9 digits.</div>
          </div>
        </form>
      </div>
    </mat-tab>

    <mat-tab label="Notes" *ngIf="!isRegionalManager">
      <mat-card>
        <form #addNotesForm="ngForm" name="NotesForm" (ngSubmit)="onAddNote(addNotesForm)" novalidate>
          <mat-form-field #addAdminNoteMatFormField class="notes-field">
            <textarea class="addNotesTextArea" appAutoAdjustTextArea matInput #noteField placeholder="Write Note Here" name="note" [(ngModel)]="model.note" #note="ngModel"></textarea>
          </mat-form-field>
          <button class="mat-raised-button submit-button add-notes-submit-btn">
            Add Note
          </button>
        </form>
      </mat-card>
      <br/>
        <mat-form-field class="notesFilter">
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" >
        </mat-form-field>
          <mat-table #table matSort [dataSource]="dataSource" class="aopa-mat-table admin-business__table">

            <ng-container matColumnDef="updateDate">
              <mat-header-cell mat-sort-header *matHeaderCellDef class="data-block__label notes_update_date">Date</mat-header-cell>
              <mat-cell *matCellDef="let note" class="notes_update_date">{{note.updateDate | date:'short'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="updateBy">
              <mat-header-cell mat-sort-header *matHeaderCellDef class="data-block__label notes_update_by">Rec Id</mat-header-cell>
              <mat-cell *matCellDef="let note" class="notes_update_by">{{note.updateBy}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="note">
                <mat-header-cell *matHeaderCellDef class="data-block__label">Note</mat-header-cell>
                <mat-cell *matCellDef="let note" class="data-block__value">
                  <mat-form-field #adminNotesMatFormField class="notes-display-field">
                    <textarea #noteTextArea appAutoAdjustTextArea class="noteTextArea" matInput placeholder="Note" [value]="note.note" [(ngModel)]="note.note"></textarea>
                  </mat-form-field>
                  <!-- cdkAutosizeTextarea -->
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="data-block__label note_actions">Actions</mat-header-cell>
              <mat-cell *matCellDef="let note" class="data-block__value note_actions">
                <button mat-icon-button (click)="onSaveNote(note)">
                  <mat-icon aria-label="Saves the note">save</mat-icon></button>
                <button mat-icon-button (click)="onDeleteNote(note)">
                  <mat-icon aria-label="Deletes the note">delete</mat-icon>
                </button>
                <span class="admin-business__deleteConfirmationAdminNotes" *ngIf="shouldDisplayDeleteButtons(businessNotesToDelete, note)">
                  <button class="mat-raised-button submit-button" (click)="deleteNote(true, note)">Delete</button>
                  <button class="mat-raised-button submit-button" (click)="deleteNote(false, note)">Cancel</button>
                </span>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="['updateDate', 'updateBy', 'note', 'actions']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['updateDate', 'updateBy', 'note', 'actions'];"></mat-row>
          </mat-table>
       <mat-paginator [pageSize]="4" [pageSizeOptions]="[2, 4, 8, 16]"></mat-paginator>
    </mat-tab>

    <mat-tab label="Change Flying Club Type" *ngIf="hasTag(business.tags, 'Flying Club')">
      <fieldset class="fieldset-container">
        <legend>Flying Club Type</legend>
          <select #clubType (change)="0">
            <option [selected]="hasTag(business.tags, 'Flying Club::AOPA::AOPA Network')"
                        value="Flying Club::AOPA::AOPA Network">AOPA Network Club</option>
            <option [selected]="hasTag(business.tags, 'Flying Club::AOPA::Proposed Club')"
                        value="Flying Club::AOPA::Proposed Club">Club in Formation</option>
            <option [selected]="!hasTag(business.tags, 'Flying Club::AOPA::AOPA Network') && !hasTag(business.tags, 'Flying Club::AOPA::Proposed Club')"
                        value="">Other</option>
          </select>
        <mat-dialog-actions><button mat-button (click)="onChangeFlyingClubType(clubType.value)">Submit</button></mat-dialog-actions>
      </fieldset>
      <fieldset class="fieldset-container" style="padding-bottom: 5px">
        <legend>Flying Club or Business</legend>
          <mat-checkbox *ngIf="FlyingClubTag" #checkboxFC [checked]="isChecked(FlyingClubTag.tagId)" [id]="FlyingClubTag.tagId"
                        (change)="checkBoxChanged($event)">This entity is a flying club (remove check to convert to a business)</mat-checkbox><br />
      </fieldset>
    </mat-tab>

    <mat-tab *ngIf="isFlightDeckAdmin" label="Delete Business">
      <div>
        <div>Why is the business being deleted?:</div>
        <mat-form-field class="deleteReason">
          <input matInput
                 #deleteReason
                 placeholder="Reason for business removal"
                 (change)="0">
        </mat-form-field>
        <div>Type 'Delete', then click delete to delete business.</div>
        <mat-form-field>
          <input matInput
                 #deleteInput
                 placeholder="Type 'Delete'"
                 (change)="0">
        </mat-form-field>
        <td><button mat-raised-button color="warn" (click)="onDelete(deleteInput.value, deleteReason.value)">Delete Business</button></td>
      </div>
    </mat-tab>

    <mat-tab label="Admin Tags" *ngIf="isFlightDeckAdmin && !hasTag(business.tags, 'Flying Club')">
      <div>
        <mat-checkbox *ngIf="FboTag" #checkbox [checked]="isChecked(FboTag.tagId)" [id]="FboTag.tagId"
                      (change)="checkBoxChanged($event)">This business is an FBO</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="FTMagTag" #checkbox [checked]="isChecked(FTMagTag.tagId)" [id]="FTMagTag.tagId"
                      (change)="checkBoxChanged($event)">Include this business in the Flight Training Magazine Pull</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="FlyingClubTag" #checkboxFC [checked]="isChecked(FlyingClubTag.tagId)" [id]="FlyingClubTag.tagId"
                      (change)="checkBoxChanged($event)">Convert business to flying club</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="HideBusinessTag" #checkboxHB [checked]="isChecked(HideBusinessTag.tagId)" [id]="HideBusinessTag.tagId"
                      (change)="checkBoxChanged($event)">Hide from Public</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="NotApprovedTag" #checkboxHB [checked]="isChecked(NotApprovedTag.tagId)" [id]="NotApprovedTag.tagId"
                      (change)="checkBoxChanged($event)">Pending Approval</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="OffersTransparentPricingTag" #checkboxOTP [checked]="isChecked(OffersTransparentPricingTag.tagId)" [id]="OffersTransparentPricingTag.tagId"
                      (change)="checkBoxChanged($event)">Offers Transparent Pricing</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="AftaSchoolTag" #checkboxOTP [checked]="isChecked(AftaSchoolTag.tagId)" [id]="AftaSchoolTag.tagId"
                      (change)="checkBoxChanged($event)">AFTA School</mat-checkbox><br />
      </div>
    </mat-tab>

    <mat-tab label="Admin Tags" *ngIf="isFlightDeckAdmin && hasTag(business.tags, 'Flying Club')">
      <div>
        <mat-checkbox *ngIf="HideBusinessTag" #checkboxHB [checked]="isChecked(HideBusinessTag.tagId)" [id]="HideBusinessTag.tagId"
                      (change)="checkBoxChanged($event)">Hide from Public</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="NotApprovedTag" #checkboxHB [checked]="isChecked(NotApprovedTag.tagId)" [id]="NotApprovedTag.tagId"
                      (change)="checkBoxChanged($event)">Pending Approval</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="FTMagTag" #checkbox [checked]="isChecked(FTMagTag.tagId)" [id]="FTMagTag.tagId"
                      (change)="checkBoxChanged($event)">Include this business in the Flight Training Magazine Pull</mat-checkbox><br />
      </div>
    </mat-tab>

    <mat-tab label="Admin Tags" *ngIf="isRegionalManager && !hasTag(business.tags, 'Flying Club')">
      <div>
        <mat-checkbox *ngIf="OffersTransparentPricingTag" #checkboxOTP [checked]="isChecked(OffersTransparentPricingTag.tagId)" [id]="OffersTransparentPricingTag.tagId"
                      (change)="checkBoxChanged($event)">Offers Transparent Pricing</mat-checkbox><br />
      </div>
    </mat-tab>

    <mat-tab *ngIf="isFlightDeckAdmin" label="Admin Dates">
      <div>
        <div *ngIf="lastVerifiedDate; else dateVerifiedPlaceholder">Last Verified: {{lastVerifiedDate}} by {{lastVerifiedBy}}</div>
        <div *ngIf="lastUpdateDate; else dateUpdatePlaceholder">Last Updated: {{lastUpdateDate}} by {{lastUpdateBy}}</div>
        <ng-container *ngIf="!hasTag(business.tags, 'Flying Club')">
          <div *ngIf="lastFeeUpdateDate; else dateFeeUpdatePlaceholder">Last Fee Update: {{lastFeeUpdateDate}} by {{lastFeeUpdateBy}}</div>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab *ngIf="isFlightDeckAdmin && isFlightSchool" label="FTE Awards">
      <mat-form-field id="date-range-select">
        <mat-select placeholder="Select Award Date(s)" [(value)]="selectedDateRange" (selectionChange)="dateRangeSelected($event)" name="dateSelect">
          <mat-option *ngFor="let dateRange of availableDateRanges" [value]="dateRange">{{dateRange}}</mat-option>
        </mat-select>
      </mat-form-field>
      <fieldset *ngIf="selectedDateRange != null">
        <div>
          <mat-checkbox *ngIf="NationalWinnerTag" [checked]="isChecked(NationalWinnerTag.tagId)" [id]="NationalWinnerTag.tagId"
                        (change)="checkBoxChanged($event)">Display National Winner Badge</mat-checkbox><br />
        </div>
        <div>
          <mat-checkbox *ngIf="DistinguishedSchoolTag" [checked]="isChecked(DistinguishedSchoolTag.tagId)" [id]="DistinguishedSchoolTag.tagId"
                        (change)="checkBoxChanged($event)">Display Distinguished School Badge</mat-checkbox><br />
        </div>
        <div>
          <mat-form-field id="region-select">
            <mat-select placeholder="Select Regional Badge" [(value)]="selectedRegionalBadgeId" (selectionChange)="regionalBadgeSelected($event)" name="regionalBadge">
              <mat-option value="0">None (Disable)</mat-option>
              <mat-option *ngFor="let regionTag of activeRegionalTags" [value]="regionTag.tagId">{{formatTagName(regionTag.tagName)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </fieldset>
      <div>
        <mat-checkbox *ngIf="DisplayCustomerFeedbackReportTag" [checked]="isChecked(DisplayCustomerFeedbackReportTag.tagId)" [id]="DisplayCustomerFeedbackReportTag.tagId"
                      (change)="checkBoxChanged($event)">Display Customer Feedback Report</mat-checkbox><br />
      </div>
      <div>
        <mat-checkbox *ngIf="DisplayPriorYearTags" [checked]="isChecked(DisplayPriorYearTags.tagId)" [id]="DisplayPriorYearTags.tagId"
                      (change)="checkBoxChanged($event)">Display Prior Year Award Badge(s)</mat-checkbox><br />
      </div>

    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions id="closeButton"><button mat-button mat-dialog-close>Close</button></mat-dialog-actions>
<ng-template #dateVerifiedPlaceholder>
  <div>Last Verified: None</div>
</ng-template>
<ng-template #dateUpdatePlaceholder>
  <div>Last Updated: None</div>
</ng-template>
<ng-template #dateFeeUpdatePlaceholder>
  <div>Last Fee Update: None</div>
</ng-template>
